import { MarriageAnscNotificationsNonResidentMutationCrumbs } from 'mutation/constants/ansc-notifications.crumbs';
import { Fragment, ReactElement } from 'react';
import PersonSearchMarriageNonResidentNotificationsCivilStatusShared from 'shell/components/shared/ansc-notifications/research-marriage-non-resident/edit-person-search';
import { IdAmbito } from 'shell/constants/id-ambito';

const PersonSearchMarriageNonResidentNotificationsCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <PersonSearchMarriageNonResidentNotificationsCivilStatusShared
        scope={IdAmbito.Mutazioni}
        items={MarriageAnscNotificationsNonResidentMutationCrumbs()}
      />
    </Fragment>
  );
};

PersonSearchMarriageNonResidentNotificationsCivilStatusPage.displayName =
  'Research Marriage Non Resident Notifications CivilStatusPage component';

export default PersonSearchMarriageNonResidentNotificationsCivilStatusPage;
